import { render, staticRenderFns } from "./LocalizedContent.vue?vue&type=template&id=6d886532"
import script from "./LocalizedContent.vue?vue&type=script&lang=ts"
export * from "./LocalizedContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports